"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObjectValue = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var LabelValueGrid_1 = require("../../components/LabelValueGrid");
var R = __importStar(require("../../utils/ramda"));
var ObjectValue = function (_a) {
  var object = _a.object,
    _b = _a.labels,
    labels = _b === void 0 ? {} : _b,
    _c = _a.pickOrder,
    pickOrder = _c === void 0 ? [] : _c,
    _d = _a.omit,
    omit = _d === void 0 ? [] : _d,
    _e = _a.showUnordered,
    showUnordered = _e === void 0 ? false : _e;
  var filteredObject = getFilteredObject(object, pickOrder, omit, showUnordered);
  var fields = getFieldsFromOrder(filteredObject, pickOrder, labels, showUnordered);
  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: fields
  });
};
exports.ObjectValue = ObjectValue;
function getFilteredObject(object, pick, omit, showUnordered) {
  if (pick === void 0) {
    pick = [];
  }
  if (omit === void 0) {
    omit = [];
  }
  if (showUnordered === void 0) {
    showUnordered = false;
  }
  var pickFn = R.isEmpty(pick) || showUnordered ? R.identity : R.pick(pick);
  var omitFn = R.isEmpty(omit) ? R.identity : R.omit(omit);
  var filteredObject = pickFn(omitFn(object));
  return filteredObject;
}
function getFieldsFromOrder(filteredObject, order, labels, showUnordered) {
  if (order === void 0) {
    order = [];
  }
  if (labels === void 0) {
    labels = {};
  }
  if (showUnordered === void 0) {
    showUnordered = false;
  }
  var keys = R.keys(filteredObject);
  var trueOrder = getOrderFromKeys(keys, order, showUnordered);
  var fields = trueOrder.map(function (prop, idx) {
    var _a;
    if (!R.has(prop, filteredObject)) {
      return null;
    }
    var label = (_a = labels[prop]) !== null && _a !== void 0 ? _a : prop;
    var value = R.prop(prop, filteredObject);
    return (0, jsx_runtime_1.jsx)(LabelValueGrid_1.LabelValue, {
      label: label,
      value: value
    }, idx);
  });
  return fields;
}
function getOrderFromKeys(keys, order, showUnordered) {
  if (showUnordered === void 0) {
    showUnordered = false;
  }
  if (R.isEmpty(order)) return keys;
  var missingKeys = keys.filter(function (key) {
    return !order.includes(key);
  });
  if (R.isEmpty(missingKeys) || !showUnordered) return order;
  return __spreadArray(__spreadArray([], __read(order), false), __read(missingKeys), false);
}